<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
  import CMSService from 'src/services/CMSService'
  export default {
    name: 'cms-details',
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id;
        let res = await CMSService.getById(id, {
          with: 'user,segments'
        });
        let cms = res.data;
        if (cms) {
          next(vm => {
            vm.$store.commit('cms/SET_CURRENT_CMS', cms)
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    }

  }
</script>
<style>
</style>
